import React from 'react';
import { TimeUtils } from "examsbook-react-sdk/common";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useStyles, usePopupHandlerOnUnload, useQuizCountDown } from "examsbook-react-sdk/custom-hooks";

/**
 * Quiz timer.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizTimer(props) {
    const classes = useStyles(styles)();
    const { mode, viewMode, duration, usedTime, setTimeTaken, pauseQuiz, submitQuiz } = props;
    const secondsLeft = useQuizCountDown(duration, usedTime, pauseQuiz, viewMode);
    //set time taken.
    const progress = (((duration * 60) - secondsLeft) / (duration * 60)) * 100;
    setTimeTaken((duration * 60) - secondsLeft);
    usePopupHandlerOnUnload(secondsLeft > 0, viewMode);
    let time = TimeUtils.secondsToTime(secondsLeft);
    if (secondsLeft === 0 && !viewMode) {
        submitQuiz();
        // Alert popup for submitting hte quiz
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-popup react-confirm-alert-body">
                        <h1>Time over!</h1>
                        <p>Your quiz has been submitted successfully!</p>
                        <button onClick={() => {
                            onClose();
                        }}>Ok
                        </button>
                    </div>
                );
            }
        });
    }

    function renderWarning() {
        return (
            ((mode === 'mock-test' || mode === 'live-test') && time.h === 0 && +time.m < 3) ?
                <div className="timer-warning"></div> : ''
        );
    }

    function renderTimer() {
        return (
            <div
                className={classes.timer + ' ' + (((mode === 'mock-test' || mode === 'live-test') && time.h === 0 && +time.m < 3) ? classes.blinkTimer : '')}>
                {
                    !viewMode ?
                        <i className="fa fa-clock-o" aria-hidden="true"/> : null
                }
                {
                    !viewMode ?
                        ((time.h > 0 ? ("0" + time.h).slice(-2) + ':' : ' 00' + ':') + ("0" + time.m).slice(-2) + ':' + ("0" + time.s).slice(-2)) : ''
                }
                {
                    !viewMode ? <LinearProgress variant="determinate" value={progress}/> : null
                }
            </div>
        );
    }

    return (
        <React.Fragment>
            {
                renderWarning()
            }
            {
                renderTimer()
            }
        </React.Fragment>
    );
}

const styles = theme => ({
    timer: {
        top: 7,
        left: 0,
        right: 'inherit',
        height: 40,
        display: 'flex',
        alignItems: 'center',
        padding: '3px 10px',
        textAlign: 'left',
        lineHeight: '40px',
        color: '#fff',
        fontSize: 16,
        flexWrap: 'wrap',
        minWidth: 100,
        position: 'relative',
        '& i': {
            color: '#5DF2D6',
            display: 'flex',
            fontSize: 18,
            marginRight: 5
        },
        '& .MuiLinearProgress-colorPrimary': {
            backgroundColor: 'rgb(18 161 136)',
            marginTop: -4,
            width: '100%',
            display: 'flex',
            '& > div': {
                backgroundColor: '#5DF2D6'
            }
        },
        '@media (max-width:767px)': {
            top: -1,
            left: 0,
            right: 'inherit',
            height: 40,
            display: 'flex',
            alignItems: 'center',
            padding: '3px 10px',
            textAlign: 'left',
            lineHeight: '40px',
            color: '#fff',
            fontSize: 14,
            flexWrap: 'wrap',
            minWidth: 100,
            width: 100,
            position: 'absolute'
        }
    }
});
export default QuizTimer;
